/*
 * Purpose : Dashboard Landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

//import React, {useState, useEffect, useContext} from 'react';
import React, {useState, useEffect} from 'react';
import {BsArrowRight} from 'react-icons/bs'
import { NavLink } from "react-router-dom";
import { Card, CardDeck, CardBody, Alert, CardFooter } from 'reactstrap';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import ButtonM from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AlertModal from './../components/UI/modals/alertModal';
import DaughnutChart from './../components/charts/DaughnutChart'
import BarChart from './../components/charts/BarChart'
import moment from 'moment'

import Aux from '../hoc/Auxilliary/Auxilliary';
import ErrorImage from '../assets/Error_2.jpg';
import LoadingModal from './../components/UI/modals/loadingModal'
//import AppContext from '../context/app-context';
//amplify
import { API, graphqlOperation } from 'aws-amplify';

const Dashboard = (props) => {
    //using context api in functional component
    // const appContext = useContext(AppContext)
    // console.log("appContext==>",appContext)
    const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,
          //boxShadow: "6px 8px 8px 8px gray"
          //backgroundImage: `url(${BgImage})`,
          display:"flex"
        },
        paper: {
          height: 100,
          width: 100,
        },
        control: {
          padding: theme.spacing(2),
        },
        cardDeck: {
            align:"center", 
            //margin:"5% 5%"
            marginTop:"1%",
            marginRight:"5%",
            marginBottom:"1%",
            marginLeft:"5%",
            //display:"flex",
            // flexWrap:"wrap",
            flex:"auto",
            justifyContent: "center",

        },
        card: {
            borderRadius: "8px",
            //boxShadow: "6px 8px 8px 8px #C0C0C0",
            boxShadow: "6px 6px 6px 6px #E0E0E0",//rgba(60, 61, 65, 0.05)",
            //padding:"1em",
            textAlign: "center",
            //width: "257px"
            border:"0px solid rgba(0,0,0,.125)",
            //height:"100%",
            //width: "85%",
            minWidth:"auto",
            marginBottom:"15px !important",
            //justifyContent: "center",

        },
        cardActionArea: {
            align:"center",
            marginTop:"10px !important",
            marginBottom:"50px"
        },
        cardAction: {
            alignSelf: "center",
            position:"absolute",
            bottom:"0"
        },
        cardFooter: {
            //alignSelf: "center",
            //position:"absolute",
            bottom:"0"
        },
        image: {
            borderRadius: "30%",
            width:"120px"
        },
      }));

      const classes = useStyles();
      const [alertModal, setAlertModal] = useState(false)
      const [error, setError] = useState(null)
      const [errorCount, setErrorCount] = useState(0)
      const [loading, setLoading] = useState(false)
      const [statusCountArray, setStatusCountArray] = useState([])
      const [toolCountArray, setToolCountArray] = useState([])

      // function to get days based on the given date range
      const getDaysBasedToolData = async (startDate, endDate) => {
            const toolQuery = `query
            {
                listExcesstransactionss(limit:${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}, filter: {approved: {ne: "DRAFT"}, and: {date: {ge: "${startDate}"}, and: {date: {le: "${endDate}"}}}}) {
                    items {
                        approved
                    }
                }
            }`;
            const toolQueryApiData =await API.graphql(graphqlOperation(toolQuery))
            const toolQueryResults = toolQueryApiData.data.listExcesstransactionss.items;
            //console.log("toolQueryResults default=>",toolQueryResults)
            //console.log("approveCount==>",toolQueryResults.length)
            return toolQueryResults.length
      }
      // function to get logs, based on the given date range
      const getData = async (startDate, endDate) => {
        setLoading(true)
        const logQuery = `query 
                    {
                        listExcesstransactionsloggers(limit:${process.env.REACT_APP_TRANSACTIONLOGS_TABLE_LIMIT}, filter: {loggeddate: {ge: "${startDate}" }, and: {loggeddate: {le: "${endDate}" }}, level: {eq: "error"} }) {
                            items {
                                level
                                loggeddate
                                message
                            }
                        }
                    }
                `;
        const logQueryApiData =await API.graphql(graphqlOperation(logQuery))
        const logQueryApiDataResults = logQueryApiData.data.listExcesstransactionsloggers.items;
        //console.log("logQueryApiDataResults default=>",logQueryApiDataResults)
        const statusQuery = `query 
                    {
                        listExcesstransactionss(limit:${process.env.REACT_APP_TRANSACTION_TABLE_LIMIT}, filter: {approved: {ne: "DRAFT"}}) {
                            items {
                                approved
                            }
                        }
                    }
                `;
        const statusQueryApiData =await API.graphql(graphqlOperation(statusQuery))
        const statusQueryResults = statusQueryApiData.data.listExcesstransactionss.items;
        console.log("statusQueryResults default=>",statusQueryResults.length)

        const statusCountArr = []
        const approveCount = statusQueryResults.reduce((acc, cur) => cur.approved === "APPROVED" ? ++acc : acc, 0);
        console.log("approveCount==>",approveCount)
        statusCountArr.push(approveCount)

        const noCount = statusQueryResults.reduce((acc, cur) => cur.approved === "NO" ? ++acc : acc, 0);
        console.log("noCount==>",noCount)
        statusCountArr.push(noCount)

        const rejectCount = statusQueryResults.reduce((acc, cur) => cur.approved === "REJECTED" ? ++acc : acc, 0);
        console.log("rejectCount==>",rejectCount)
        statusCountArr.push(rejectCount)

        const toolCountArr = []
        const lastTenDaysCount = await getDaysBasedToolData(moment().subtract(10, 'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD"))
        toolCountArr.push(lastTenDaysCount)
        const lastThirtyDaysCount = await getDaysBasedToolData(moment().subtract(30, 'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD"))
        toolCountArr.push(lastThirtyDaysCount)
        const lastSixtyDaysCount = await getDaysBasedToolData(moment().subtract(60, 'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD"))
        toolCountArr.push(lastSixtyDaysCount)

        console.log("lastTenDaysCount=>",lastTenDaysCount)
        console.log("lastThirtyDaysCount=>",lastThirtyDaysCount)
        console.log("lastThirtyDaysCount=>",lastThirtyDaysCount)
        
        setErrorCount(logQueryApiDataResults.length)
        setStatusCountArray(statusCountArr)
        setToolCountArray(toolCountArr)
        setLoading(false)
    }
    
    useEffect(() => {
        //console.log("user=>", props.user)
        const buildData = async() => {
            //let data = await getData(moment().subtract(7, 'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD"))
            await getData(moment().subtract(7, 'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD"))
            //console.log("data==>",data)
        }
        buildData()
    }, [])
    
    return(
        <Aux>
        <LoadingModal open={loading} msg="Loading..." />
        <Alert color="danger" isOpen={error}>{error}</Alert>
        <AlertModal open={alertModal} msg="You do not have rights to access this page.!" handler={setAlertModal}/>
        <Grid container className={classes.root}>
            <CardDeck className={classes.cardDeck}>   
                <Card className={classes.card}>
                    <CardActionArea className={classes.cardActionArea} onClick={ () => {} }>                        
                        <CardContent>                        
                            <h4 style={{textAlign:"left", marginBottom:"15%"}}>Tools Status</h4>
                            <DaughnutChart dataArr={statusCountArray}/>
                        </CardContent>
                    </CardActionArea>                    
                </Card>
                <Card className={classes.card}>
                    <CardActionArea className={classes.cardActionArea} onClick={ () => {} }>                        
                        <CardContent>
                            <h4 style={{textAlign:"left", marginBottom:"15%"}}>Tools Submitted</h4>
                            <BarChart dataArr={toolCountArray}/>
                        </CardContent>
                    </CardActionArea>                    
                </Card>
                <Card className={classes.card}>
                    <CardBody>  
                            <h4 style={{textAlign:"left", marginBottom:"10%"}}>Application Logs</h4>
                            <span>
                                <img src={ErrorImage} alt="error symbol" className={classes.image} />
                            </span>                         
                            <Typography variant="inherit" color="textSecondary" component="h5" style={{paddingTop:"10%"}}>
                                There are {errorCount} errors / exceptions in the last 7 days
                            </Typography>
                    </CardBody>
                    <CardFooter className={classes.cardFooter}>
                        <NavLink style={{ textDecoration: 'none'}} to="/dashboard/logs"  exact>
                        <ButtonM  style={{color:"#337ab7" }} >
                        <BsArrowRight style={{ fontSize: 30}}/><b>  &nbsp;&nbsp;Detailed Logs</b>
                        </ButtonM>
                        </NavLink>
                    </CardFooter>
                </Card>
            </CardDeck>
        </Grid>
        </Aux>
    );
}
export default Dashboard;